<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard" [dragula]='"widget-bag"'>
  <swb-social></swb-social>
  <swb-gdpr></swb-gdpr>
  <swb-scripts></swb-scripts>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard" [dragula]='"widget-bag"'>
  <swb-seo-settings></swb-seo-settings>
  <swb-email-signatures></swb-email-signatures>
</div>
